export default __webpack_public_path__ + "static/media/shopify.ca236e12.png";